import { gql } from 'graphql-request'
import { useQuery, UseQueryOptions } from '@/proxy/react-query'
import { client } from '@/proxy/client'
import { DeliveryType } from '@/resources/enums'
import { ActiveOrder, DeliveryDate, QueryDataError } from '@/resources/types'
import { getScheduledOrders } from '@/pages/ScheduledOrders/utils.ts'

export const ACTIVE_ORDERS_FOR_SIDEBAR = gql`
  query sellerActiveOrders {
    activeOrders {
      status
      date
      delivery {
        type
        deliveryDate {
          startDate
          endDate
        }
      }
    }
  }
`
export const ACTIVE_ORDERS_FOR_SIDEBAR_QUERY_KEY = 'useActiveOrdersForSidebar'

export interface ActiveOrdersData {
  activeOrders?: {
    status: string
    date: string
    delivery: {
      type: DeliveryType
      deliveryDate: DeliveryDate
    }
  }
  error?: QueryDataError
}

export const useActiveOrdersForSidebar = (
  options: Omit<UseQueryOptions<ActiveOrdersData>, 'queryKey'>,
  callback: (scheduledOrders: ActiveOrder[]) => void
) => {
  return useQuery<ActiveOrdersData>({
    queryKey: [ACTIVE_ORDERS_FOR_SIDEBAR_QUERY_KEY],
    queryFn: (): Promise<ActiveOrdersData> => {
      return client.request<ActiveOrdersData>(ACTIVE_ORDERS_FOR_SIDEBAR)
    },
    onSuccess: ({ activeOrders = [], error }) => {
      if (error) return
      callback(getScheduledOrders({ orders: activeOrders as ActiveOrder[] }))
    },
    ...options,
  })
}
